import {fonts} from '../../theme/foundations/fonts'
import sizes from '../../theme/foundations/sizes'
import {pxToRem} from '../../utills/pxToRem'

export const breadcrumbItemStyle = {
    fontFamily: fonts.primary,
    fontSize: pxToRem(13),
    fontWeight: '400',
    letterSpacing: pxToRem(1),
    textDecoration: 'uppercase',
    color: 'cav_light_input_gray',
    a: {
        padding: '0'
    },
    [`@media (max-width: ${sizes.container.md})`]: {
        fontSize: pxToRem(12)
    }
}
